import script from "./DateInputChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateInputChip.vue?vue&type=script&setup=true&lang=ts"

import "./DateInputChip.vue?vue&type=style&index=0&id=13da719e&lang=postcss"

const __exports__ = script;

export default __exports__